import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from './en';

const i18nProvider = polyglotI18nProvider(locale => {
    // Always fallback on english
    return englishMessages;
}, 'en');

export { i18nProvider }